import React,{useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ButtonBase from '@material-ui/core/ButtonBase';
import Typography from '@material-ui/core/Typography';
// import './Button.css';
import {useHistory} from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    minWidth: 300,
    width: '100%',
    justifyContent:'space-evenly',

  },
  image: {
    position: 'relative',
    height: 340,
    borderRadius:'21.66px',
    // marginRight:15,
    [theme.breakpoints.down('xs')]: {
      width: '100% !important', // Overrides inline-style
      height: 100,
    },
    // onClick: () => history.push("/"),
    '&:hover, &$focusVisible': {
      zIndex: 1,
      '& $imageBackdrop': {
        opacity: 0.15,
      },
      '& $imageMarked': {
        opacity: 0,
      },
      '& $imageTitle': {
        border: '4px solid currentColor',
      },
    },
  },
  focusVisible: {},
  imageButton: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.common.black,
  },
  imageSrc: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center 40%',
    borderRadius:'21.66px',
    border: '0.4vh solid blue',

  },
  imageBackdrop: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: theme.palette.common.black,
    opacity: 0.4,
    transition: theme.transitions.create('opacity'),
    borderRadius:'21.66px',

   },
  imageTitle: {
    position: 'relative',
    fontWeight:'bold',
    fontSize:'3vh',
    color:'#000',
    padding: `${theme.spacing(2)}px ${theme.spacing(4)}px ${theme.spacing(1) + 6}px`,
  },
  imageMarked: {
    height: 3,
    width: 18,
    backgroundColor: theme.palette.common.black,
    position: 'absolute',
    bottom: -2,
    left: 'calc(50% - 9px)',
    transition: theme.transitions.create('opacity'),
  },
}));


  


export default function ButtonBases() {
  const classes = useStyles();
  const history = useHistory();

  function handlebtn1(){
    history.push('/query');
  }

  function handlebtn2(){
    history.push('/register');

  }

//   function handlebtn3(){
//     history.push('/violations');
//   }

  return (
    <div className={classes.root}>
    
      <ButtonBase
          onClick={handlebtn1}
          focusRipple
          key={1}
          className={classes.image}
          focusVisibleClassName={classes.focusVisible}
          style={{
            width: "32%",
          }}
        >
          <span
            className={classes.imageSrc}
            style={{
              backgroundImage: `url('https://firebasestorage.googleapis.com/v0/b/pandemic-control.appspot.com/o/Query.png?alt=media&token=29473d05-eb68-4728-be38-4e821d00300f')`,
             
            }}
          />
          <span className={classes.imageBackdrop} />
          <span className={classes.imageButton}>
            <Typography
              component="span"
              variant="subtitle1"
              color="inherit"
              className={classes.imageTitle}
            >
              <p>QUERIES</p>
              <span className={classes.imageMarked} />
            </Typography>
          </span>
        </ButtonBase>

        <ButtonBase
        onClick={handlebtn2}
        focusRipple
        key={2}
        className={classes.image}
        focusVisibleClassName={classes.focusVisible}
        style={{
          width: "32%",
        }}
      >
          <span
          className={classes.imageSrc}
          style={{
            backgroundImage: `url('https://firebasestorage.googleapis.com/v0/b/pandemic-control.appspot.com/o/Register-now_teal_splash.jpg?alt=media&token=87b32416-7cfa-4f69-af97-436aebd25adc')`,
           
          }}
        />
        <span className={classes.imageBackdrop} />
        <span className={classes.imageButton}>
          <Typography
            component="span"
            variant="subtitle1"
            color="inherit"
            className={classes.imageTitle}
          >
            <p>REGISTER</p>
            <span className={classes.imageMarked} />
          </Typography>
        </span>
      </ButtonBase>

      {/* <ButtonBase
        onClick={handlebtn3}
        focusRipple
        key={2}
        className={classes.image}
        focusVisibleClassName={classes.focusVisible}
        style={{
          width: "32%",
        }}
      >
        <span
          className={classes.imageSrc}
          style={{
            backgroundImage: `url('https://thumbs-prod.si-cdn.com/WhfhBXdLb-89w2TFcqdmqz-6JEQ=/fit-in/1600x0/https://public-media.si-cdn.com/filer/1f/93/1f9331e9-e7dc-4255-ba69-c910410321f3/bloodbag.jpg')`,
           
          }}
        />
        <span className={classes.imageBackdrop} />
        <span className={classes.imageButton}>
          <Typography
            component="span"
            variant="subtitle1"
            color="inherit"
            className={classes.imageTitle}
          >
            <p>VIOLATIONS</p>
            <span className={classes.imageMarked} />
          </Typography>
        </span>
      </ButtonBase> */}
    </div>
  );
}